export const ADMIN_ROLE_ID = 1;
export const FRONT_OFFICE_ID = '2';
export const INVENTORY_MANAGER_ID = '3';
export const ANALYST_ROLE_ID = '4';
